import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
// waiting for gemini component, accessibility constraint
export const AccessibilityWrapper = ({ id, children }) => (_jsx(Box, { id: id, as: "span", borderWidth: "borderWidth.none", position: "absolute", maxHeight: "1px", maxWidth: "1px", overflow: "hidden", whiteSpace: "nowrap", clipPath: "inset(50%)", unsafe_style: {
        clip: "rect(1px, 1px, 1px, 1px)",
    }, children: children }));
